var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.colors.productContentItem &&
    _vm.colors.productContentItem.productStyleImages.length > 0
    ? _c(
        "VueSlickCarousel",
        _vm._b(
          {
            scopedSlots: _vm._u(
              [
                {
                  key: "nextArrow",
                  fn: function() {
                    return [
                      _c(
                        "button",
                        {
                          staticClass: "custom-arrow-next",
                          attrs: { type: "button" }
                        },
                        [
                          _c("span", {
                            staticClass:
                              "png-icon png-icon-icons-glyph--k-chevron-right"
                          })
                        ]
                      )
                    ]
                  },
                  proxy: true
                },
                {
                  key: "prevArrow",
                  fn: function() {
                    return [
                      _c(
                        "button",
                        {
                          staticClass: "custom-arrow-prev",
                          attrs: { type: "button" }
                        },
                        [
                          _c("span", {
                            staticClass:
                              "png-icon png-icon-icons-glyph--k-chevron-left"
                          })
                        ]
                      )
                    ]
                  },
                  proxy: true
                }
              ],
              null,
              false,
              2598201106
            )
          },
          "VueSlickCarousel",
          _vm.settings,
          false
        ),
        [
          _vm._v(" "),
          _vm._v(" "),
          _vm._l(_vm.colors.productContentItem.productStyleImages, function(
            color
          ) {
            return _c("div", { key: color.colorNumber }, [
              _c("img", {
                staticClass: "slick-img-fluid",
                attrs: { src: color.imageLink, alt: "img" },
                on: {
                  click: function($event) {
                    return _vm.previewModal(color, _vm.colors)
                  }
                }
              })
            ])
          })
        ],
        2
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }